// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const AcceptingNewPatientSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g fill="#FCFBFC" fillRule="evenodd">
        <path d="M25.57 34.357c.386.147.715.46.882.877.3.75-.117 1.583-.9 1.895-2.006.668-4.084 1.012-6.182 1.012-4.942 0-9.57-1.886-13.04-5.23-.128-.077-.223-.17-.3-.298C2.512 29.12.5 24.386.5 19.32.5 8.948 8.994.5 19.37.5c10.367 0 18.82 8.438 18.82 18.82 0 .82-.667 1.49-1.486 1.49-.82 0-1.488-.67-1.488-1.49 0-8.71-7.134-15.845-15.846-15.845-8.728 0-15.845 7.102-15.845 15.846 0 3.688 1.25 7.155 3.504 9.938 1.335-1.89 3.124-3.53 5.253-4.804.437-.22.997-.22 1.46.015 1.514.874 3.94 1.808 5.282 1.808.57 0 1.257-.133 2.177-.424.76-.227 1.63.22 1.857.978.13.437.038.91-.208 1.278v5.283c0 1.07.936.945.936.945h.847c.296-.1.602-.093.88 0h.067l-.013.02z" />
        <path d="M19.21 7.846c-4.14 0-6.5 2.582-6.5 7.123 0 4.23 3.205 8.37 6.5 8.37 3.383 0 6.5-4.008 6.5-8.37 0-4.542-2.36-7.124-6.5-7.124zM34.65 23.66c0-.42-.343-.765-.764-.765h-2.982c-.42 0-.765.344-.765.765v3.48h-3.48c-.42 0-.765.343-.765.764v2.982c0 .42.344.765.765.765h3.48v3.48c0 .42.343.765.764.765h2.982c.42 0 .765-.344.765-.765v-3.48h3.48c.42 0 .765-.343.765-.764v-2.982c0-.42-.344-.765-.765-.765h-3.48v-3.48z" />
      </g>
    </svg>
  </SvgContainer>
);

AcceptingNewPatientSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default AcceptingNewPatientSvg;
